import type { FaireProductEntity } from "../../entity_types/product";

export const p_7bnuz3zwg6: FaireProductEntity = {
  token: "p_7bnuz3zwg6",
  type: "product",
  name: "Feel Better De-Stress Ball, Pretzel",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl:
    "https://cdn.faire.com/fastly/9b4a21a28938f2f7372c8cbd18e2724cdc817f0f72366962f608ab366c3968a3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53ef261a1553ba7e6c245559ff8b7f33e0061ab6f7795b9553bb097d9f3241c5.jpeg",
    "https://cdn.faire.com/fastly/67bf219cc9e49ac7e560e75aca7f7bd6a511b7d3df83a146d349db811cfcff90.jpeg",
    "https://cdn.faire.com/fastly/cece77e7f42bbeeeae7a0757bcb6c0fad7261964a2a544bd14ad2a094e1b1068.jpeg",
    "https://cdn.faire.com/fastly/bcecfd5ebc7109b4f9de8d74a855cb6e13d8659100072756e7213208c5997195.jpeg",
    "https://cdn.faire.com/fastly/b1d3da182ac0a2bd4e81c55775451ee118b9e0020a0bb5f4134c51418724df97.jpeg",
    "https://cdn.faire.com/fastly/c590d6635dedc0e5581bdeb2a2f3a7235ed2e301cb0395f71bf1c2d96e58fdd6.jpeg",
  ],
  priceDollars: 6,
  description:
    "Let it all out with this pretzel-shaped de-stress ball. Made from slow-rising polyurethane foam, it always bounces back—no matter how tight you squeeze. Perfect for relieving tension, boosting focus, or just having a little fun at your desk. So go ahead—twist, squish, and relax. This pretzel isn’t going anywhere.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n\n• Pretzel-shaped design made of slow-rising polyurethane foam\n• Returns to its original shape after every squeeze\n• Great for stress relief, fidgeting, or mindful moments\n• Compact and lightweight—perfect for on-the-go use\n• Designed in ban.do’s signature bright, playful style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫:\n\n• Gift shops and lifestyle boutiques\n• Wellness and novelty retailers\n• Students, professionals, and fidget toy lovers\n• Wholesale buyers seeking fun, functional stress-relief accessories",
  tags: [],
  msrpDollars: 12.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:42.565Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
